/*
 * PROD-7828 R10 — the query strings the Reports tab sends: the reports and the needs-attention issues
 * CSV (CD-36). The blocked panel's /recalc uses the upload builder; the audit trail builds its own.
 * Pure; request_fields.test.js pins every builder to the handler's published field list (CD-139).
 */
import { issues_params } from '../needs_attention/params';

// Reports take the Overview's month ("YYYY-MM").
const PAY_MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;
const month_or_empty = (pay_month) => (PAY_MONTH_RE.test(pay_month || '') ? pay_month : '');

export const status_params = (pay_month) => ({ pay_month: month_or_empty(pay_month) });

// preview is "1" for the first rows, "0" for the whole report; the server refuses anything else.
export const data_params = (report, pay_month, preview) => ({
  report,
  pay_month: month_or_empty(pay_month),
  preview: preview ? '1' : '0'
});

export const csv_params = (report, pay_month) => ({
  report,
  pay_month: month_or_empty(pay_month)
});

// ---- CD-36: the to-be-reviewed sessions CSV ----

// The CSV binds the list's own IssuesQuery, so it gets the list's filters and a valid page; the
// server ignores the page and writes every matching row.
export const ISSUES_CSV_LIMIT = 100;

export const issues_csv_params = (filters) => issues_params(filters, ISSUES_CSV_LIMIT, 0);
